import { Keypair, Signer } from "@solana/web3.js";

const CONSTRUCTION_KEY = "ConstructionSigner";

export const saveConstructionSigner = (construction: Signer) => {
  window.localStorage.setItem(
    CONSTRUCTION_KEY,
    JSON.stringify([...construction.secretKey])
  );
};

export const getConstructionSignerFromStorage = (): Signer | undefined => {
  const k = window.localStorage.getItem(CONSTRUCTION_KEY);
  if (!k) return undefined;
  const arr: number[] = JSON.parse(k);
  const sk = new Uint8Array(arr);
  return Keypair.fromSecretKey(sk);
};
